import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/dashboard/store/selectors/dashboard';

export const statesSelector = createSelector(dashboardSelector, (state) => state.states);
